// Small key-value store: UserDefaults on iOS, SharedPreferences on Android, localStorage on the web.
// Not for large data or secrets.
import { Preferences } from "@capacitor/preferences";

/** Returns the parsed value for `key`, or undefined when missing or unreadable. */
export async function loadJson(key: string): Promise<unknown> {
  try {
    const { value } = await Preferences.get({ key });
    return value === null ? undefined : (JSON.parse(value) as unknown);
  } catch {
    return undefined;
  }
}

export async function saveJson(key: string, data: unknown): Promise<void> {
  await Preferences.set({ key, value: JSON.stringify(data) });
}
